export const asyncTypes = ['REQUEST', 'SUCCESS', 'FAILURE', 'CLEAN'] as const;
